import moment from 'moment';
import React from 'react'
import { Table, Modal, Button } from 'react-frontier';
import { Link } from 'react-router-dom';

interface InfoLogProps {
	open: boolean;
	onClose: () => void;
	data: {
		user_id?: number;
		user_creator?: number;
		user_creator_name?: string;
		date_created?: number;

		added?: boolean;
		user_added?: number;
		user_added_name?: string;
		date_added?: number;

		approved?: boolean;
		user_approved?: number;
		user_approver_name?: string;
		date_approved?: number;

		cancelled?: boolean;
		user_cancelled?: number;
		user_cancelled_name?: string;
		date_cancelled?: number;

		deleted?: boolean;
		user_deleted?: number;
		user_deleted_name?: string;
		date_deleted?: number;

		paid?: boolean;
		user_paid?: number;
		user_paid_name?: string;
		date_paid?: number;

		rated?: boolean;
		user_rated?: number;
		user_rated_name?: string;
		date_rated?: number;

		[key: string]: any;
	};
	title?: string;
	style?: React.CSSProperties;
}

export default function InfoLog(props: InfoLogProps){
	var data = props.data;
	if(!data) return null;

	var renderUserLink = (userId?: number, userName?: string)=>{
		if(!userId) return null;
		
		return <>
			<Link target='_blank' className='normal' to={`/users/${userId}`}>
				{userName || `Usuario #${userId}`}
			</Link>
			<div className="meta">ID: {userId}</div>
		</>;
	};

	var tableData: any[] = [];

	if((data.user_id || data.user_creator) || data.date_created){
		if(data.user_id || data.user_creator){
			tableData.push(['Creado por', renderUserLink(data.user_id || data.user_creator, data.user_creator_name)]);
		}
		if(data.date_created){
			tableData.push(['Fecha creación', moment.unix(data.date_created).format('DD/MMM/YY HH:mm')]);
		}
	}
	if(data.user_added){
		tableData.push(null);
		tableData.push(['Agregado por', renderUserLink(data.user_added, data.user_added_name)]);
		if(data.date_added){
			tableData.push(['Fecha agregado', moment.unix(data.date_added).format('DD/MMM/YY HH:mm')]);
		}
	}
	if(data.approved && data.user_approved){
		tableData.push(null);
		tableData.push(['Aprobado por', renderUserLink(data.user_approved, data.user_approver_name)]);
		if(data.date_approved){
			tableData.push(['Fecha aprobación', moment.unix(data.date_approved).format('DD/MMM/YY HH:mm')]);
		}
	}
	if(data.paid && data.user_paid){
		tableData.push(null);
		tableData.push(['Pagado por', renderUserLink(data.user_paid, data.user_paid_name)]);
		if(data.date_paid){
			tableData.push(['Fecha pagado', moment.unix(data.date_paid).format('DD/MMM/YY HH:mm')]);
		}
	}
	if(data.cancelled && data.user_cancelled){
		tableData.push(null);
		tableData.push(['Cancelado por', renderUserLink(data.user_cancelled, data.user_cancelled_name)]);
		if(data.date_cancelled){
			tableData.push(['Fecha cancelado', moment.unix(data.date_cancelled).format('DD/MMM/YY HH:mm')]);
		}
	}
	if(data.rated && data.user_rated){
		tableData.push(null);
		tableData.push(['Calificado por', renderUserLink(data.user_rated, data.user_rated_name)]);
		if(data.date_rated){
			tableData.push(['Fecha calificación', moment.unix(data.date_rated).format('DD/MMM/YY HH:mm')]);
		}
	}
	if(data.deleted && data.user_deleted){
		tableData.push(null);
		tableData.push(['Eliminado por', renderUserLink(data.user_deleted, data.user_deleted_name)]);
		if(data.date_deleted){
			tableData.push(['Fecha eliminado', moment.unix(data.date_deleted).format('DD/MMM/YY HH:mm')]);
		}
	}

	return (
		<Modal open={props.open} onClose={props.onClose} size='tiny'>
			<Modal.Header>{props.title}</Modal.Header>
			<Modal.Content style={{ paddingBottom: 0 }}>
				<Table
					fitted
					details 
					striped
					data={tableData}
				/>
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={props.onClose} />
			</Modal.Actions>
		</Modal>
	);
}